import buttonBase from './_buttonBase';
export default {
  extends: buttonBase,
  methods: {
    performAction: function performAction() {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      var layoutParameter = this.button ? this.button.layoutParameter : '';

      if (layoutParameter) {
        this.$_appendToQueryString(decodeURIComponent(layoutParameter), "&position=" + this.$_getAnalyticsPosition());
      } else {
        setTimeout(window.print, 1);
        this.$_raiseAnalyticsEvent('Print');
      }

      return true;
    },
    $_appendToQueryString: function $_appendToQueryString(parameter, position) {
      var queryString = window.location.search;

      if (queryString.length === 0) {
        window.location.search = "?" + parameter + position;
      } else {
        window.location.search = queryString + "&" + parameter + position;
      }
    }
  }
};